export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_zh_CN.9abbfdb97879f9b0.json"